angular.module('data-ng-path-item').constant(
  'PresenterModeEnum',
  Enumeration('PresenterModeEnum', {
    DISPLAY: 'DISPLAY',
    MOBILE: 'MOBILE',
    TAGS: 'TAGS',
    EDIT: 'EDIT'
  })
);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/types/item_presenter_mode_enum.js